const MAX_BYTES = 180000;

export function readHubThumbnail(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      resolve("");
      return;
    }
    if (!/^image\/(png|jpe?g|webp|gif)$/i.test(file.type)) {
      reject(new Error("Please choose a simple image — PNG, JPG, or WebP."));
      return;
    }
    if (file.size > MAX_BYTES) {
      reject(new Error("Please choose a smaller image."));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result || ""));
    reader.onerror = () => reject(new Error("That image could not be read."));
    reader.readAsDataURL(file);
  });
}
